module.exports = __webpack_public_path__ + "img/INF-B-2-I.3d7a0bab.png";